<template>
  <pt-gene-report-order class="pt-gene-report-order__page"></pt-gene-report-order>
</template>

<script>
import PtGeneReportOrder from 'cps/lab-order/pt-gene-report-order/withData'
export default {
  name: 'pt-gene-report-order__view',
  components: {
    'pt-gene-report-order': PtGeneReportOrder
  }
}
</script>
